const applyIfDefined = (f?: () => void): void => { if (f) { f(); } };

export default applyIfDefined;
